import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import http from "../services/httpService";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});
function BrokerManager() {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [activeBrokers, setActiveBrokers] = useState([]);
  const [testEnvironmentBrokers, setTestEnvironmentBrokers] = useState([]);
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter")
    localStorage.removeItem("selectedfiltersdata")
    localStorage.removeItem("selectedinvestorfiltersdata")

    toast.loading("Please wait...");

    http
      .get("/brokers_list")
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data["Test Environment Brokers"] &&
          Array.isArray(res.data["Test Environment Brokers"]) &&
          res.data["Test Environment Brokers"].length > 0
        ) {
          setTestEnvironmentBrokers(res.data["Test Environment Brokers"]);
          toast.dismiss();
        }
        if (
          res &&
          res.data &&
          res.data["Active Brokers"] &&
          Array.isArray(res.data["Active Brokers"]) &&
          res.data["Active Brokers"].length > 0
        ) {
          setActiveBrokers(res.data["Active Brokers"]);
        }
      })
    // .catch((err) => { });
  }, []);
  return (
    <Grid
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
      className="pb30"
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        style={{ marginTop: 30 }}
        align="center"
      >
        <Typography color="textPrimary" variant="h5">
          Broker Manager
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: "20px" }} className={"prospectgrids"}>
        <Grid item xs={12} sm={6} md={6} className="pb30">
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ backgroundColor: "#F5F7FA" }}
          >
            <Typography variant="h6">Active Broker List</Typography>
          </Grid>
          {activeBrokers.map((label, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                key={index + "_" + label}
                style={{ marginTop: 20 }}
              >
                <Typography variant="body2">{label}</Typography>
              </Grid>
            );
          })}
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="pb30">
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ backgroundColor: "#F5F7FA" }}
          >
            <Typography variant="h6">Test Environment Brokers</Typography>
          </Grid>

          {testEnvironmentBrokers.map((label, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                key={index + "_" + label}
                style={{ marginTop: 20 }}
              >
                <Typography variant="body2">{label}</Typography>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BrokerManager;
